export default {
  GET_PDK_COMPONENTS: state => {
    return state.pdkComponents;
  },
  GET_KEN_COMPONENTS: state => {
    return state.kenComponents;
  },
  getEcologyTypeList: state => {
    return state.ecologyType;
    // return state.todos.find(todo => todo.id === id);
  },
  getParentRegions: state => {
    return state.parentRegions;
  },
  getAllRegions: state => {
    return state.allRegions;
  },
  getMinistry: state => {
    return state.ministry;
  },
  getActivityField: state => {
    return state.activityField;
  },
  getDepartments: state => {
    return state.departments;
  },
  getSubordination: state => {
    return state.subordination;
  },
  getOwnership: state => {
    return state.ownership;
  },
  getEcologyType: state => {
    return state.ecologyType;
  },
  getMeasurmentUnits: state => {
    return state.measurmentUnits;
  },
  getObjectsParameters: state => {
    return state.objectsParameters;
  },
  getSourceParameters: state => {
    return state.sourceParameters;
  },
  getDangerCategories: state => {
    return state.dangerCategories;
  }
};
